import { Progress } from "antd";
import { primary10 } from "../../../constants/colors";
import { Heading } from "../../elements/Elements";
import { currencyFormat, formatLargeNumber } from "../../../utils/helpers";
import { IsAdmin } from "../../../utils/permissionUtils";

export const FundingCard = ({
  progress = 0,
  funded = 0,
  balance = 0,
}: {
  progress?: number;
  funded?: number;
  balance?: number;
}) => {
  // Funding progress is admin-only — hide for everyday users
  if (!IsAdmin()) return null;
  const roundedProgress = Math?.round(progress || 0);
  return (
    <div className="flexColumn gap10 lightBg p15 r10">
      <Heading>Funding Progress</Heading>
      <div className="font12 grey">
        This loan has {roundedProgress}% funded of the total amount
      </div>
      <Progress
        type="line"
        percent={roundedProgress}
        trailColor={primary10}
        status="active"
      />
      <div className="flexSpaceCenter font12 grey">
        <div>UGX {formatLargeNumber(funded)} Funded</div>
        <div>UGX {formatLargeNumber(balance)} Balance</div>
      </div>
    </div>
  );
};
